module.exports = __webpack_public_path__ + "img/wuhua.d0375bda.png";